<template >
<div>

  <!-- ENTER PHONE NUMBER -->
  <div class="modal fade" id="twoFactorAuthSmsPhoneModal" tabindex="-1" aria-labelledby="twoFactorAuthSmsPhoneTitle" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md two-factor-auth-sms">
      <div class="modal-content">
        <div class="modal-header bg-transparent">
          <button id="twoFactorAuthSmsPhoneModalClose" type="button" class="btn-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
        </div>
        <div class="modal-body pb-5 px-sm-5 mx-50">
          <h4>Verify Your Mobile Number for SMS</h4>
          <p>Enter your mobile phone number with country code and we will send you a verification code.</p>
          <a href="javascript:void(0)" hidden id="openTwoFactorAuthSmsModal" data-target="#twoFactorAuthSmsModal" data-toggle="modal">clicker</a>

          <form class="row gy-1 mt-1">
            <div class="col-12" v-if="app_status">

              <vue-tel-input
                  ref="phone_number"
                  v-bind:class="!isValid  ? 'is-invalid' : ''"
                  v-bind:style="[ !isValid ? { borderColor: '#ea5455' } : {}]"
                  v-model="phone_no"
                  @input="input"
                  @validate="validate"
                  v-bind:default-country="defaultCountry"
                  :inputOptions="{name: name}"
                  readonly
              ></vue-tel-input>
              <span class="invalid-feedback" role="alert">
                  <strong>{{ message }}</strong>
              </span>

            </div>
            <div class="col-12" v-else>

              <vue-tel-input
                  ref="phone_number"
                  v-bind:class="!isValid  ? 'is-invalid' : ''"
                  v-bind:style="[ !isValid ? { borderColor: '#ea5455' } : {}]"
                  v-model="phone_no"
                  @input="input"
                  @validate="validate"
                  country="US"
                  v-bind:default-country="US"
                  :onlyCountries="['US']"
                  :inputOptions="{name: name}"
                  readonly
              ></vue-tel-input>
              <span class="invalid-feedback" role="alert">
                  <strong>{{ message }}</strong>
              </span>

            </div>
            <div class="col-12 d-flex justify-content-end" v-if="update_status">
              <button type="reset" class="btn btn-outline-secondary mt-1 me-1 waves-effect mr-1" data-dismiss="modal" aria-label="Close">
                Cancel
              </button>
              <button type="button" class="btn btn-primary mt-1 waves-effect waves-float waves-light" v-on:click="addPhoneNumber">
                <span class="me-50">Continue</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>
              </button>
            </div>
            <div class="col-12 d-flex justify-content-end mt-1" v-else>
              <p class="text-danger">You can update your phone number every 30 days.</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- E ENTER PHONE NUMBER -->
  <!--  ENTER SMS CODE -->
  <div class="modal fade" id="twoFactorAuthSmsModal" tabindex="-1" aria-labelledby="twoFactorAuthSmsTitle" style="display: nones;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md two-factor-auth-sms">
      <div class="modal-content">
        <div class="modal-header bg-transparent">
          <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
        </div>
        <div class="modal-body pb-5 px-sm-5 mx-50">
          <h4>Verify Your Mobile Number </h4>
          <p class="card-text mb-75">
            We sent a verification code to your mobile. Enter the code from the mobile in the field below.
          </p>
          <form class="mt-2" v-on:submit.prevent="verifyOtp">
            <h6>Type your 6 digit security code</h6>
            <div class="auth-input-wrapper-otp d-flex align-items-center justify-content-between">
              <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
                maxlength="1" autofocus="" v-model="input_1"/>

              <input class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
                maxlength="1" type="text"  v-model="input_2"/>

              <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
                maxlength="1"  v-model="input_3"/>

              <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
                maxlength="1"  v-model="input_4"/>

              <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
                maxlength="1"  v-model="input_5"/>

              <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
                maxlength="1"  v-model="input_6"/>
            </div>
            <div>
              <p class="text-danger" v-if="error != ''" >{{error}}</p>
            </div>
            <button type="submit" class="btn btn-primary w-100" tabindex="4">Update Phone Number</button>
          </form>
          <p class="text-center mt-2">
            <span>Didn’t get the code?</span><a href="#" v-on:click ="resendCode"><span>&nbsp;Resend</span></a>
          </p>
          <p class="text-center mt-2">
            <span class="text-success" v-if="resend_res">{{resend_res}}</span> <!-- <span v-if="time_left > 0">Time left : {{time_left}}</span> -->
          </p>
        </div>
      </div>
    </div>
  </div>
  <!-- END ENTER SMS CODE -->
</div>
</template>
<script>
import {
  BCard, BButton, BAvatar, BRow, BCol,
} from 'bootstrap-vue-3'
import axios from 'axios'
import {ref} from 'vue'
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import 'flatpickr/dist/flatpickr.css';

// import 'vue-select/dist/vue-select.css';
export default{
    components: {
        BCard,
        BButton,
        BRow,
        BCol,
        BAvatar,
        VueTelInput
    },
    setup() {
        return {
            date: ref(new Date()),
            stateUser: ref([]),
            message: 'Not A Valid Number',
            defaultCountry: null,
            update_status: ref(null),
        }
    },
    data() {
        return {
            phone_no:'',
            input_1:'',
            input_2:'',
            input_3:'',
            input_4:'',
            input_5:'',
            input_6:'',
            error:'',
            isValid: false,
            resend_res:false,
            time_left:0,
            name:null,
            app_status:null
        }
    },
    props: {
        phone: {
            type: String,
            default: () => {},
        },
        name: {
            type: String,
            default: () => {},
        },
    },
    computed:{

    },
    created() {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const ct = require('countries-and-timezones');
        axios.get(`${baseUrl}/app/status`)
        .then(({data})=>{
            if(data.data == true){
                this.app_status = true
                const country = ct.getTimezone(timezone).countries[0];
                if (country === "" || !country) {
                    this.defaultCountry = 'US';
                    return;
                }
                this.defaultCountry = country;
            }else{
                this.defaultCountry = 'US';
            }
        });
    },
    mounted(){
        this.authentication();
        this.canUpdatePhone();
    },
  methods: {
      input: function (event, object) {
        this.$refs.phone_number.$emit('validate', this.$refs.phone_number.phoneObject);
      },
      validate: function (Object) {
        if(Object) {
            this.isValid = Object.valid;
        }
      },
      canUpdatePhone(){
        var status ={
          'status':0
        }
        axios.post(`${baseUrl}/otp/user/check`,status).then(({data})=>{
          this.update_status = data.data.update_status;
        }).catch((e)=>{
          toastr.error('An Error Occured please try again!','Two Step Verification');
        });
      },
      addPhoneNumber(){
        var twoFactorAuthModalClose = document.getElementById('openTwoFactorAuthSmsModal');
        if(this.phone_no.length > 10){
          this.requestOtp();
        }else{
          toastr.error('Please check your phone number and try again.','Two Step Verification')
        }

      },
      requestOtp(){
        let status = {
          'status':0,
          'option':this.two_step_factor?'disable':'enable',
          'type':'update_phone',
          'phone':this.phone_no
        }
        if(!this.isValid){
          return toastr.error('The number you entered is not valid.','Two Step Verification');
        }
        // if(this.time_left !== 0){
        //   return toastr.error('Please wait for the timer to finish its count.','Two Step Verification');
        // }
        axios.post('/otp/add/send/phone',status).then(({data})=>{
          // this.limitRequest();
          this.time_left = 0;
          if(data.error == true){
            return toastr.error(data.data,'Two Step Verification');
          }
          this.showVerifyField();
          return toastr.success(data.data,'Two Step Verification');
        }).catch((e)=>{
            if(e.response.status == 429){
              return toastr.error(`${e.response.statusText}, please try agian after 1 minute.`,'Two Step Verification');
            }
            return toastr.error(`Please use International Number format when attempting to update or add a number.`,'Two Step Verification');
        })
      },
      resendCode(e){
        e.preventDefault();
        let status = {
          'status':0,
          'type':'update_phone',
          'phone':this.phone_no
        }
        // if(this.time_left !== 0){
        //   return toastr.error('Please wait for the timer to finish its count.','Two Step Verification');
        // }
        axios.post('/otp/add/send/phone',status).then(({data})=>{
          this.time_left = 0;
          if(data.error == true){
            return toastr.error('Please check if you have added your phone number and try again.','Two Step Verification');
          }
          // this.limitRequest()
          return toastr.success(`${data.data}`,'Two Step Verification');
        }).catch((e)=>{
          if(e.response.status == 429){
            return toastr.error(`${e.response.statusText}, please try agian after 1 minute.`,'Two Step Verification');
          }
          return toastr.error(`${e.response.statusText}`,'Two Step Verification');
        })
      },
      limitRequest(){
        let time_left = 60;
        this.request_code = setInterval(()=>{
          time_left --;
          if(time_left < 0){
            clearInterval(this.request_code)
          }else{
            if(time_left > 10 || time_left == 0){
              time_left = time_left
            }else{
              time_left = '0'+time_left
            }
            this.time_left = parseInt(time_left);
          }
        },1000);
      },
      showVerifyField(){
        var openTwoFactorAuthSmsModal = document.getElementById('openTwoFactorAuthSmsModal');
        var twoFactorAuthSmsPhoneModalClose = document.getElementById('twoFactorAuthSmsPhoneModalClose');
        openTwoFactorAuthSmsModal.click();
        twoFactorAuthSmsPhoneModalClose.click()
      },
      verifyOtp(e){
        e.preventDefault();
        let h = this;
        this.otpcode = `${h.input_1}${h.input_2}${h.input_3}${h.input_4}${h.input_5}${h.input_6}`;
        var otpcode = this.otpcode,route='',verified=false;
        var token = {
          'token':otpcode,
          'type':'update_phone',
          'phone':this.phone_no
        }
        if(this.checkIfNotEmpty(otpcode) && this.phone !== ""){
          axios.post('/otp/add/phone',token).then(({data})=>{
            if(data.message == 'success message'){
              toastr.success(data.data,'Two Step Verification');
              setTimeout(()=>{
                this.cancelMobileModel()
                window.location.reload()
              },1000)
            }else{
              toastr.error(data.data,'Two Step Verification');
            }
          }).catch((e)=>{
            console.log(e);
            toastr.error('An Error Occured please try agains!','Two Step Verification');
          });
        }else{
          //  Two Steps Verification
          const numeralMask = document.querySelectorAll('.numeral-mask');
          if (numeralMask.length) {
            numeralMask.forEach(e => {
              if(h.checkIfNotEmpty(e.value)){
                e.classList.add('isValid')
                this.error = ''
              }else{
                e.classList.add('isInvalid')
                this.error = 'All fields must be filled'
              }
            });
          }
        }
      },
      checkIfNotEmpty(val){
        this.error = ''
        if((val !=="" || val !==null ) && typeof Number(val) && val.length == 6){
          return true;
        }else{
          return false;
        }
      },
      cancelMobileModel(){
        var twoFactorAuthSmsModal = document.getElementById('twoFactorAuthSmsModal');
        var modal_backdrop = document.getElementsByClassName('modal-backdrop');
        modal_backdrop.forEach(e=>{
          e.remove();
        })
        // modal_backdrop = modal_backdrop.classList.remove('show');
        twoFactorAuthSmsModal.style.display = 'none';
        twoFactorAuthSmsModal.removeAttribute('role','dialog');
        twoFactorAuthSmsModal.classList.remove('show');
      },
      authentication(){
        var inputContainer = document.querySelector('.auth-input-wrapper-otp');
        // Get focus on next element after max-length reach
        inputContainer.onkeyup = function (e) {
          var target = e.srcElement;
          var maxLength = parseInt(target.attributes['maxlength'].value, 10);
          var currentLength = target.value.length;

          if (e.keyCode === 8) {
            if (currentLength === 0) {
              var next = target;
              while ((next = next.previousElementSibling)) {
                if (next == null) break;
                if (next.tagName.toLowerCase() == 'input') {
                  next.focus();
                  break;
                }
              }
            }
          } else {
            if (currentLength >= maxLength) {
              var next = target;
              while ((next = next.nextElementSibling)) {
                if (next == null) break;
                if (next.tagName.toLowerCase() == 'input') {
                  next.focus();
                  break;
                }
              }
            }
          }
        };
      },
  },

}
</script>
